var customCheckmarksForImgOptions = function() {

  // Written for aloha theme
  
  const panels = document.querySelectorAll('.cpb-product-panel');

  const appendSVG = (elem) => {
      const svg = document.createElement('div');
      svg.classList.add('cpb-checkmark');
      svg.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="20.14" height="20.14" viewBox="0 0 20.14 20.14">
              <g id="Group_104" data-name="Group 104" transform="translate(899 -2478)">
               <circle id="Ellipse_7" data-name="Ellipse 7" cx="10.07" cy="10.07" r="10.07" transform="translate(-899 2478)" fill="#fff"/>
              <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle" d="M20.7,10.632A10.069,10.069,0,1,1,10.632.563,10.069,10.069,0,0,1,20.7,10.632ZM9.467,15.963l7.471-7.471a.65.65,0,0,0,0-.919l-.919-.919a.65.65,0,0,0-.919,0L9.007,12.748,6.163,9.9a.65.65,0,0,0-.919,0l-.919.919a.65.65,0,0,0,0,.919l4.222,4.222a.65.65,0,0,0,.919,0Z" transform="translate(-899.563 2477.438)"/>
            </g>
          </svg>  
        `
     elem.appendChild(svg);
  }

  panels[0].querySelectorAll('.cpb-option-type-img').forEach(option => appendSVG(option));
  
  const mutationObserver = new MutationObserver((mutations, observer) => {
    const activeItem = mutations.find(rec => rec.target.classList.contains('react-tabs__tab-panel--selected'));
    const activeElem = activeItem.target;
    const imgOptions = activeElem.querySelectorAll('.cpb-option-type-img')
    if (imgOptions.length) {
      imgOptions.forEach(option => {
        appendSVG(option);
      })
    }
  })

  const config = {
    childList: true
  }
  
  panels.forEach(panel => mutationObserver.observe(panel, config));

}


var cpbLoaded = function() {
    if (document.querySelectorAll('.cpb-product-panel').length > 0) {
      
      customCheckmarksForImgOptions();
    } else {
      window.requestAnimationFrame(cpbLoaded);
    }   
};

cpbLoaded();